module.exports = __webpack_public_path__ + "img/liangrongyanwo.eb07c873.jpg";